import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	copiedConfirmationTitleNonFinal: {
		id: 'eoc-changeboarding.services.store.chat-tools.actions.copied-confirmation-title-non-final',
		defaultMessage: 'Copied link',
		description: 'Title for the Confirmation Flag',
	},
	copiedSuccessNonFinal: {
		id: 'eoc-changeboarding.services.store.chat-tools.actions.copied-success-non-final',
		defaultMessage:
			'Share it with your Teams Administrator to ask for their authorization to give permission.',
		description: 'Description for successful link copy flag',
	},
	copiedFailedNonFinal: {
		id: 'eoc-changeboarding.services.store.chat-tools.actions.copied-failed-non-final',
		defaultMessage: 'Something went wrong, please try again? If you need help, contact support.',
		description: 'Description for failed link copy flag',
	},
	duplicateNotPartOfChannelTitleNonFinal: {
		id: 'eoc-changeboarding.services.store.chat-tools.actions.duplicate-not-part-of-channel-title-non-final',
		defaultMessage: "You aren't a member of the connected channel",
		description: 'Title for the duplicate error when user is not part of channel',
	},
	duplicateNotPartOfChannelDescriptionNonFinal: {
		id: 'eoc-changeboarding.services.store.chat-tools.actions.duplicate-not-part-of-channel-description-non-final',
		defaultMessage:
			"This integration is connected to a chat channel or conversation that you aren't a member of. Join the channel and try again.",
		description: 'Description for the duplicate error when user is not part of channel',
	},
	duplicateGenericErrorTitleNonFinal: {
		id: 'eoc-changeboarding.services.store.chat-tools.actions.duplicate-generic-error-title-non-final',
		defaultMessage: "Couldn't copy your integration",
		description: 'Title for the duplicate generic error',
	},
	duplicateGenericErrorDescriptionNonFinal: {
		id: 'eoc-changeboarding.services.store.chat-tools.actions.duplicate-generic-error-description-non-final',
		defaultMessage:
			'Something went wrong while copying your integration to Jira. Try again in some time. If you still need help, contact support.',
		description: 'Description for the duplicate generic error',
	},
	contactSupportBtnLabelNonFinal: {
		id: 'eoc-changeboarding.services.store.chat-tools.actions.contact-support-btn-label-non-final',
		defaultMessage: 'Contact support',
		description: 'Button label for Contacting Support',
	},
});
